export default function CTA() {
    return (
        <div className="cta">
            <p>Masz pytania? Zadzwoń</p>
            <a href="tel:+34604432520">+32 604 432 520</a>
        </div>
    )
}